import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
export var NestedCheckboxModel = /*#__PURE__*/_createClass(function NestedCheckboxModel(item, label, checked) {
  _classCallCheck(this, NestedCheckboxModel);

  _defineProperty(this, "item", void 0);

  _defineProperty(this, "label", void 0);

  _defineProperty(this, "checked", void 0);

  this.item = item;
  this.label = label;
  this.checked = checked;
});